import { connect } from 'react-redux';
import type { Post } from '@app/types/core';
import { openScheduledCommonRoomPosts } from '@app/actions/navigation/openScheduledPosts';
import { COMMON_ROOM } from '@core/constants/postFeedType';
import {
  accessingCurrentSpaceAsStaff,
  hasFinishedFetchingPostsSelector,
  isInstructor,
  isUpdatingPostIdInSpace,
} from '@core/selectors/classroom';
import { currentUserId } from '@core/selectors/user';
import {
  getNextScheduledPost,
  getScheduledPostsCount,
} from '@core/selectors/space';
import { deleteSpacePost, editSpacePost } from '@core/actions/space/posts';
import { canDeletePost } from '../../Shared/PostCard/permissions';
import ScheduledPostsSummary from './ScheduledPostsSummary';

export type ScheduledPostsSummaryOwnProps = {
  scheduledPost?: Post | null;
};

export const mapStateToProps = (
  state,
  { scheduledPost: scheduledPostOverride }: ScheduledPostsSummaryOwnProps = {}
) => {
  const scheduledPost =
    scheduledPostOverride ?? getNextScheduledPost(state, COMMON_ROOM);
  const userId = currentUserId(state);

  return {
    canDeleteScheduledPost: Boolean(
      scheduledPost &&
        canDeletePost({
          isAuthor: scheduledPost.user.objectId === userId,
          isEducator: isInstructor(state, userId),
          isReadOnlyUser: accessingCurrentSpaceAsStaff(state),
        })
    ),
    hasFinishedFetchingPosts: hasFinishedFetchingPostsSelector(state),
    isUpdatingScheduledPost: scheduledPost
      ? isUpdatingPostIdInSpace(state)(scheduledPost.objectId)
      : false,
    scheduledPost,
    scheduledPostCount: getScheduledPostsCount(state, COMMON_ROOM),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onDeleteScheduledPost: (post) => dispatch(deleteSpacePost(post.objectId)),
  onViewScheduledPosts: (isMobile?: boolean) =>
    dispatch(openScheduledCommonRoomPosts(isMobile)),
  reschedulePost: (postData: any) => {
    dispatch(editSpacePost(postData));
  },
  handlePublishPost: (postId) => {
    dispatch(
      editSpacePost({
        postId,
        scheduledFor: null,
        content: undefined,
      })
    );
  },
});

export default connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  ScheduledPostsSummaryOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(ScheduledPostsSummary);
